// Driver contract and the "add a workflow" recipe live in ./README.md.

import {CallPostScanModule} from '../../actions/scanpackAction';

// v1 step names (Record/Verify) sit alongside the v2 module names because both
// versions feed the same engine.
export const INTERACTIVE_MODULES = {
  packing_cam: 'openPackingCam',
  record_tracking_number: 'promptRecordTracking',
  verify_shipping_label: 'promptVerifyShipping',
  re_scan_order_items: 'reScanOrderItems',
  shipping_label_ui: 'openShippingLabel',
  Record: 'promptRecordTracking',
  Verify: 'promptVerifyShipping'
};

export function runPostScanModules(driver, {order, orderId, modules = [], toteInput = null}) {
  return async dispatch => {
    if (!Array.isArray(modules) || modules.length === 0) {
      return {shouldFinalize: true};
    }

    for (let i = 0; i < modules.length; i++) {
      const moduleName = modules[i];
      const remainingModules = modules.slice(i + 1);
      const hookName = INTERACTIVE_MODULES[moduleName];
      const hook = hookName && driver?.[hookName];

      if (hook) {
        // false means the module didn't apply to this order, so carry on rather
        // than pausing.
        const tookOver = await dispatch(hook({order, orderId, remainingModules, toteInput}));
        if (tookOver !== false) return {shouldFinalize: false};
        continue;
      }

      // true means the workflow ran the step itself instead of the backend.
      if (driver?.runStep) {
        const handled = await dispatch(
          driver.runStep({moduleName, order, orderId, remainingModules, toteInput})
        );
        if (handled) continue;
      }

      await dispatch(CallPostScanModule(moduleName, orderId));
    }

    return {shouldFinalize: true};
  };
}

// Single entry point for both starting and resuming a pipeline.
export function runPostScanFlow(driver, params) {
  return async dispatch => {
    const {shouldFinalize} = await dispatch(runPostScanModules(driver, params));
    if (shouldFinalize && driver?.finalize) {
      await dispatch(driver.finalize(params));
    }
    return {shouldFinalize};
  };
}
